export default class DataSetColLongEditor
{
	name;
    label;
    visible = true;
    helpText = null;
    displayLength = 20;
    alignment = "Center";
    showZero = false;
    thousandSeperator = false ;
    type = "Long";
}


// WEBPACK FOOTER //
// ./src/universalView/dataSet/DataSetColLongEditor.js